import { Trans } from 'react-i18next';

// TODO replace every <Trans> that doesn't have a nested React Component with the `t-function`

export default Trans;
